export default __webpack_public_path__ + "static/media/three.7af2df45.png";